import { createSelector } from 'reselect';
import { visibleAccountsSelector, accountsSelector } from './AccountsStepSelector';
import { isNonEmptyString } from '../../../../../js/app/react/validators';

export const formatMoney = number => `$${window.ADV.util.number_format(number, 0, '.', ',')}`;

export const composeLabel = (description, accountName) => {
  if (isNonEmptyString(accountName)) {
    return accountName;
  }
  if (isNonEmptyString(description)) {
    return description;
  }
  return 'Untitled';
};

export const accountsOverviewSelector = createSelector(visibleAccountsSelector, accounts =>
  accounts
    .filter(({ ShowAccount }) => ShowAccount)
    .map(
      ({
        AccountId,
        Description,
        AccountName,
        frontEndId,
        NonSpecificPositionsValue,
        IsLinked,
      }) => ({
        id: AccountId || frontEndId,
        label: composeLabel(Description, AccountName),
        value: formatMoney(NonSpecificPositionsValue),
        isLink: IsLinked,
        isGhost: false,
      }),
    ),
);

export const noDeletedAccountsSelector = createSelector(
  accountsSelector,
  graphAccounts => !graphAccounts.some(({ IsDeleted }) => IsDeleted),
);

export const isEmptyStateSelector = createSelector(
  accountsOverviewSelector,
  accountsOverview => accountsOverview.length === 0,
);
